import styled from 'styled-components';

export const OnHoverStoreHeaderStyling = styled.div`
  padding: 0 100px;
  margin-top: 10px;
  margin-bottom: 10px;
  display: none;
`;
export const CategoriesStyling = styled.div`
  display: flex;
  flex-direction: ${(props) => (props.showColumnStyle ? '' : 'column')};
  padding: 10px 12px;
  column-gap: 30px;
  border-radius: 0 0 16px 16px;
  background-color: #fffcf5;
  .brandHeading {
    font-size: 14px;
    color: #773a3f;
    padding: 10px;
    display: block;
    width: max-content;
    font-weight: bold !important;
    &:hover {
      color: #773a3f;
      background: rgba(0, 0, 0, 0.2);
    }
  }
  .content {
    padding: 10px;
    text-align: left;
    font-size: 13px;
    background-color: transparent;
    display: block;
    transition: all 0.2s linear;
    color: #555;
    &:hover {
      color: #773a3f;
      background: rgba(0, 0, 0, 0.2);
    }
  }
  .innerContainer {
    // flex-basis: 15%;
  }
`;
